import React, { useContext } from 'react';
import Currency from '@prisjakt/ui-currency';
import { AppContext } from '@prisjakt/ui-app-context';

const PriceFrom: React.FC<IPriceFromProps> = props => {
  const { price } = props;
  const { t } = useContext(AppContext);

  if (!price) {
    return <>`${t('product', 'price.from')} -`</>;
  }

  return (
    <>
      {t('product', 'price.from')} <Currency price={price} />
    </>
  );
};

interface IPriceFromProps {
  price?: number | null;
}

export default PriceFrom;
